import TagManager from '@sooro-io/react-gtm-module'
import type { TrackingEvent, TrackingEventData } from '@/types/tracking'
import { daysToMs } from '@/utils/datetime/unitToMs'
import Cookies from 'universal-cookie'

declare global {
	interface Window {
		dataLayer: any
		gtag: any
	}
}

export type ConsentChoices = {
	adConsentGranted: boolean
	adUserDataConsentGranted: boolean
	adPersonalizationConsentGranted: boolean
	analyticsConsentGranted: boolean
}

type GtagConsentMode = {
	ad_storage: 'granted' | 'denied'
	ad_user_data: 'granted' | 'denied'
	ad_personalization: 'granted' | 'denied'
	analytics_storage: 'granted' | 'denied'
}

const cookies = new Cookies(null, { path: '/', expires: new Date(Date.now() + daysToMs(365)) })

function makeConsentMode(consent: 'granted' | 'denied'): GtagConsentMode {
	return ['ad_storage', 'ad_personalization', 'analytics_storage', 'ad_user_data'].reduce(
		(acc, key) => ({
			...acc,
			[key]: consent
		}),
		{} as GtagConsentMode
	)
}

export function getOrMakeConsentMode() {
	const consentMode = cookies.get('consent_mode')

	return consentMode ?? makeConsentMode('denied')
}

export function updateConsent(isGranted: boolean) {
	const updatedConsentMode = makeConsentMode(isGranted ? 'granted' : 'denied')

	gtag('consent', 'update', updatedConsentMode)

	cookies.set('consent_mode', updatedConsentMode)
}

export function gtag(...args: any[]) {
	if (typeof window !== 'undefined') {
		if (typeof window.gtag === 'undefined') {
			window.dataLayer = window.dataLayer || []
			window.gtag = function gtag() {
				window.dataLayer.push(arguments)
			}
		}

		window.gtag(...args)
	}
}

export function setupGTM(gtmId: string) {
	const defaultConsent = getOrMakeConsentMode()

	gtag('consent', 'default', defaultConsent)

	TagManager.initialize({
		gtmId
	})
}

export function sendEvent<T extends TrackingEvent>(eventName: T, data?: TrackingEventData<T>) {
	TagManager.dataLayer({
		dataLayer: {
			event: eventName,
			...(data as object)
		}
	})
}
